import MaterialTable from "material-table";
import tableIcons from "../../../utils/tableIcons";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
// import Loader from "../../shared/Loader";
import {
  GetPromotionsBySpId,
  GetServiceProviderById,
} from "../../../utils/api";
import Loader from "../../shared/Loader";
import { Empty, Popover, message } from "antd";
import dayjs from "dayjs";
import { CaretDownFilled } from "@ant-design/icons";

const Promocodes = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [promocodes, setPromocodes] = useState([]);

  const tableRef = useRef(null);

  const getServiceById = async () => {
    setLoading(true);
    try {
      const res = await GetServiceProviderById(id);
      if (res?.isSuccess) {
        getPromocodes(res?.data?.user_id);
      } else {
        message.error("Error while fetching details, Please try again");
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getPromocodes = async (userId) => {
    try {
      const response = await GetPromotionsBySpId(userId);
      if (response?.isSuccess) {
        setPromocodes(response?.items);
        setLoading(false);
      } else {
        setLoading(false);
        message.error(response?.error);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Promocode",
      field: "name",
      sorting: false,
      cellStyle: { width: "20%" },
      render: (record) => {
        const content = (
          <table>
            <thead>
              <tr>
                <th>Promo Code</th>
                <th>Client Name</th>
                <th>Date/Time of Redemption</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {record.userPromoCodes && record.userPromoCodes.length > 0 ? (
                record.userPromoCodes.map((promoCode) => (
                  <tr key={promoCode.id}>
                    <td>#{promoCode.id}</td>
                    <td>{promoCode?.user?.name}</td>
                    <td>
                      {dayjs(promoCode?.createdAt).format("DD/MM/YYYY, HH:mm")}
                    </td>
                    <td>
                      <span
                        className={`capitalize ${
                          promoCode?.appliedStatus === "success"
                            ? "text-[green]"
                            : "text-[red]"
                        }`}
                      >
                        {promoCode.appliedStatus}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="w-full">
                  <td className="py-4">
                    <h1 className="text-sm font-semibold absolute left-[200px]">
                      No data found.
                    </h1>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        );
        return (
          <Popover content={content} title={false} trigger="click">
            <div className="flex items-center gap-x-1">
              <span>{record?.name}</span>
              <CaretDownFilled />
            </div>
          </Popover>
        );
      },
    },
    {
      title: "Validity Period",
      field: "endDate",
      sorting: false,
      cellStyle: { width: "20%" },
      render: (record) => {
        return <span>{dayjs(record?.endDate).format("DD MMM YYYY")}</span>;
      },
    },
    {
      title: "Used Till Now",
      field: "usedTillNow",
      sorting: false,
      cellStyle: { width: "20%" },
      render: (record) => {
        return <span>{record?.usedTillNow}</span>;
      },
    },
    {
      title: "Discount",
      field: "discount",
      sorting: false,
      cellStyle: { width: "20%" },
      render: (record) => {
        return <span>£{record?.discount}</span>;
      },
    },
    {
      title: "Usage Limit",
      field: "usageLimit",
      sorting: false,
      cellStyle: { width: "20%" },
      render: (record) => {
        return <span>{record.usageLimit}</span>;
      },
    },
  ];

  useEffect(() => {
    getServiceById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="w-full flex flex-col gap-y-6">
      <div className="w-full flex flex-col gap-y-4">
        <div className="search-custom-space main-scroll w-full min-h-[calc(100vh-170px)] bg-white h-[380px] overflow-scroll flex flex-col gap-y-5 relative">
          {promocodes && promocodes?.length > 0 ? (
            <MaterialTable
              title="Support Tickets"
              tableRef={tableRef}
              columns={columns}
              icons={tableIcons}
              options={{
                showTitle: false,
                draggable: false,
                paging: false,
                debounceInterval: 700,
                padding: "dense",
                paginationType: "stepped",
                searchFieldVariant: "outlined",
                searchFieldAlignment: "left",
              }}
              data={promocodes}
            />
          ) : (
            <div className="w-full text-center my-16 font-medium text-primary-900 text-xl">
              <Empty description="No data found yet!" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Promocodes;
